module.exports = __webpack_public_path__ + "static/dashboard-shot-5d867da4294cc3b4c7f282cb01a1a4d2.png";